import {
  SHIPMENTS_COUNT_ACTION_TYPES,
  ACTIVE_SHIPMENTS_COUNT_ACTION_TYPES,
} from 'utils/actions/shipments'

const defaultState = {
  isFetching: null,
  filters: {},
  hasNextPage: null,
  error: null,
  shipmentsCount: [],
  activeShipmentsCount: 0,
}

const {
  REQUEST_SHIPMENTS_COUNT,
  SHIPMENTS_COUNT_FAILURE,
  SHIPMENTS_COUNT_SUCCESS,
} = SHIPMENTS_COUNT_ACTION_TYPES

const {
  ACTIVE_SHIPMENTS_COUNT_FAILURE,
  ACTIVE_SHIPMENTS_COUNT_SUCCESS,
  REQUEST_ACTIVE_SHIPMENTS_COUNT,
} = ACTIVE_SHIPMENTS_COUNT_ACTION_TYPES

const shipmentsCountReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case REQUEST_SHIPMENTS_COUNT: {
      const {
        payload: { filters },
      } = action
      return {
        ...state,
        isFetching: true,
        filters,
      }
    }
    case SHIPMENTS_COUNT_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        shipmentsCount: action.payload.count,
      }
    }
    case SHIPMENTS_COUNT_FAILURE: {
      const { error } = action
      return {
        ...state,
        isFetching: false,
        error,
        shipmentsCount: 0,
      }
    }
    case REQUEST_ACTIVE_SHIPMENTS_COUNT: {
      const {
        payload: { filters },
      } = action
      return {
        ...state,
        isFetching: true,
        activeShipmentsCount: 0,
        filters,
      }
    }
    case ACTIVE_SHIPMENTS_COUNT_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        activeShipmentsCount: action.payload.count,
      }
    }
    case ACTIVE_SHIPMENTS_COUNT_FAILURE: {
      const {
        payload: { error, filters, nextPage },
      } = action
      return {
        ...state,
        isFetching: false,
        error,
        hasNextPage: nextPage,
        filters,
      }
    }
    default:
      return state
  }
}

export default shipmentsCountReducer
